import React from 'react';
import TimeTrackingApp from './SprintStatistics/TimeTrackingApp';
import LoadingDots from './common/LoadingDots';
import { useUser } from '../context/UserContext';
import { usePermissions } from '../hooks/usePermissions';
import { PERMISSIONS } from '../constants/permissions';

function Dashboard() {
  const { activeJiraAccount, loading, user } = useUser();
  const { can } = usePermissions();

  const permissionsReady = !loading && !!user;
  const hasWorklogAccess = permissionsReady && can(PERMISSIONS.WORKLOG);

  return (
    <div className="min-h-screen bg-slate-100 dark:bg-slate-900 font-sans pt-6 transition-colors duration-300">
      {/* Main Content */}
      <main className="max-w-[1600px] mx-auto p-0 px-5">
        {!permissionsReady ? (
          <div className="mt-10 flex justify-center">
            <LoadingDots message="Loading..." />
          </div>
        ) : hasWorklogAccess ? (
          <TimeTrackingApp activeJiraAccount={activeJiraAccount} />
        ) : (
          <div className="mt-10 max-w-xl mx-auto bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-200 dark:border-white/10 p-6 text-center">
            <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-2">
              Access to Time Tracking is restricted
            </h1>
            <p className="text-sm text-slate-600 dark:text-slate-400">
              Your account does not have permission to view the time tracking dashboard. If you
              believe this is an error, please contact an administrator.
            </p>
          </div>
        )}
      </main>
    </div>
  );
}

export default Dashboard;